export default __webpack_public_path__ + "static/media/config-hub.d642d99f.svg";